/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/fujitsu-launchpad/Vega/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'vega';

export const ApiKey: Record<Environment, string> = {
  vega: '928eb3e78ced5c45efdcd001d55d4083',
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '1',
    branch: 'main',
    source: 'web',
    versionId: '25fd5b69-8cab-45e6-9452-e2e49e136d4b',
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0',
    },
  },
};

export interface LoadOptionsBase {
  disabled?: boolean;
}

export type LoadOptionsWithEnvironment = LoadOptionsBase & {
  environment: Environment;
  client?: { configuration?: BrowserOptions };
};
export type LoadOptionsWithApiKey = LoadOptionsBase & {
  client: { apiKey: string; configuration?: BrowserOptions };
};
export type LoadOptionsWithClientInstance = LoadOptionsBase & {
  client: { instance: BrowserClient };
};

export type LoadOptions =
  | LoadOptionsWithEnvironment
  | LoadOptionsWithApiKey
  | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * learner, creator
   */
  userType?: string;
}

export interface ClickActivityCardPortfolioProperties {
  /**
   * Indicates where the learner is coming from - Portfolio Page, Learning Section, etc.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Portfolio, LearningSection |
   */
  pageContext?: 'Portfolio' | 'LearningSection';
  /**
   * used to identify each section
   */
  section?: string;
  /**
   * Types of section templates inside modules that can be selected by the creator. Examples - RichContent, Canvas, ReviewPeer, Quiz, UploadContent
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | RichContent, StickyNote, ReviewAndComment, UploadContent, Quiz, AIChat, BlockSuiteCanvas |
   */
  sectionType?:
    | 'RichContent'
    | 'StickyNote'
    | 'ReviewAndComment'
    | 'UploadContent'
    | 'Quiz'
    | 'AIChat'
    | 'BlockSuiteCanvas';
}

export interface ClickAddCommentProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickAddSectionProperties {
  /**
   * Types of section templates inside modules that can be selected by the creator. Examples - RichContent, Canvas, ReviewPeer, Quiz, UploadContent
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | RichContent, StickyNote, ReviewAndComment, UploadContent, Quiz, AIChat, BlockSuiteCanvas |
   */
  sectionType?:
    | 'RichContent'
    | 'StickyNote'
    | 'ReviewAndComment'
    | 'UploadContent'
    | 'Quiz'
    | 'AIChat'
    | 'BlockSuiteCanvas';
}

export interface ClickAnswerChoiceProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickBackToJourneyProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface ClickCancelUploadProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface ClickCloseAiChatProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickCommentCardProperties {
  /**
   * received, given
   */
  commentsTab?: string;
}

export interface ClickConceptGlossaryProperties {
  /**
   * used to identify each concept in the glossary page.
   */
  concept?: string;
}

export interface ClickContinueButtonJourneyCardProperties {
  /**
   * This property is used to identify each journeys. (Intentionally did not make it 'journey name' as name could be edited by the creator)
   */
  journey?: string;
}

export interface ClickContinueLearningProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface ClickCtaButtonProperties {
  /**
   * Includes CTA button types such as Submit, Next, Come Back Later, Continue Learning, Back to Journey, Take Again, Mark as Complete.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Submit, Next, Come Back Later, Take Again, Mark as Completed, Done |
   */
  ctaButtonType?:
    | 'Submit'
    | 'Next'
    | 'Come Back Later'
    | 'Take Again'
    | 'Mark as Completed'
    | 'Done';
  /**
   * Types of Quiz Blocks such as Multiple Choice, Fill in the Blank, Free input, etc
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Matching, Ranking, Text, MultipleChoiceQuestion, FreeInput, Slider, FillInBlank, StickyNotes, ReviewAndComment, Upload, Chatbot, BlockSuiteCanvas |
   */
  quizBlockType?:
    | 'Matching'
    | 'Ranking'
    | 'Text'
    | 'MultipleChoiceQuestion'
    | 'FreeInput'
    | 'Slider'
    | 'FillInBlank'
    | 'StickyNotes'
    | 'ReviewAndComment'
    | 'Upload'
    | 'Chatbot'
    | 'BlockSuiteCanvas';
  /**
   * Types of section templates inside modules that can be selected by the creator. Examples - RichContent, Canvas, ReviewPeer, Quiz, UploadContent
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | RichContent, StickyNote, ReviewAndComment, UploadContent, Quiz, AIChat, BlockSuiteCanvas |
   */
  sectionType?:
    | 'RichContent'
    | 'StickyNote'
    | 'ReviewAndComment'
    | 'UploadContent'
    | 'Quiz'
    | 'AIChat'
    | 'BlockSuiteCanvas';
}

export interface ClickHideMenuProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickJourneyCardProperties {
  /**
   * This property is used to identify each journeys. (Intentionally did not make it 'journey name' as name could be edited by the creator)
   */
  journey?: string;
}

export interface ClickLinkProperties {
  /**
   * used to identify each section
   */
  section?: string;
  url: string;
}

export interface ClickLinkGlossaryProperties {
  /**
   * used to identify each concept in the glossary page.
   */
  concept?: string;
}

export interface ClickMarkAsCompleteProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickModuleBarProperties {
  /**
   * used to identify module
   */
  module?: string;
}

export interface ClickNextProperties {
  /**
   * Indicates whether the activity is in a success or fail state when the user takes the action.
   */
  quizResultStatus?: string;
  /**
   * Types of section templates inside modules that can be selected by the creator. Examples - RichContent, Canvas, ReviewPeer, Quiz, UploadContent
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | RichContent, StickyNote, ReviewAndComment, UploadContent, Quiz, AIChat, BlockSuiteCanvas |
   */
  sectionType?:
    | 'RichContent'
    | 'StickyNote'
    | 'ReviewAndComment'
    | 'UploadContent'
    | 'Quiz'
    | 'AIChat'
    | 'BlockSuiteCanvas';
}

export interface ClickRemoveFileProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface ClickScaleProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickSendAiChatProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickSortProperties {
  /**
   * Column names in Submissions page. Examples: name, assignment, type, submitted date, comments etc.
   */
  submissionsColumn?: string;
  /**
   * Tabs inside the submission page e.g. Submitted, Reviewed
   */
  submissionTab?: string;
}

export interface ClickStageProperties {
  /**
   * used to identify stages.
   */
  stage?: string;
}

export interface ClickStartAiChatProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface ClickStartButtonProperties {
  /**
   * used to identify module
   */
  module?: string;
}

export interface ClickTabCommentsProperties {
  /**
   * received, given
   */
  commentsTab?: string;
}

export interface ClickTabSubmissionsProperties {
  /**
   * Tabs inside the submission page e.g. Submitted, Reviewed
   */
  submissionTab?: string;
}

export interface ClickTakeAgainProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface ClickUploaderProperties {
  /**
   * used to identify each section
   */
  section?: string;
}

export interface CopyOfClickComeBackLaterProperties {
  /**
   * used to identify each section
   */
  section: string;
}

export interface SelectLanguageProperties {
  /**
   * Tracks selected language from language menu option.
   */
  language?: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(public event_properties?: IdentifyProperties) {
    this.event_properties = event_properties;
  }
}

export class AddEditor implements BaseEvent {
  event_type = 'Add Editor';
}

export class ClickActivityCardPortfolio implements BaseEvent {
  event_type = 'Click Activity Card - Portfolio';

  constructor(public event_properties?: ClickActivityCardPortfolioProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickAddComment implements BaseEvent {
  event_type = 'Click Add Comment';

  constructor(public event_properties?: ClickAddCommentProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickAddSection implements BaseEvent {
  event_type = 'Click Add Section';

  constructor(public event_properties?: ClickAddSectionProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickAnswerChoice implements BaseEvent {
  event_type = 'Click Answer Choice';

  constructor(public event_properties?: ClickAnswerChoiceProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickAvatarTopNavigation implements BaseEvent {
  event_type = 'Click Avatar - Top Navigation';
}

export class ClickBackToJourney implements BaseEvent {
  event_type = 'Click Back to Journey';

  constructor(public event_properties: ClickBackToJourneyProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickCancelEditProfile implements BaseEvent {
  event_type = 'Click Cancel - Edit Profile';
}

export class ClickCancelUpload implements BaseEvent {
  event_type = 'Click Cancel Upload';

  constructor(public event_properties: ClickCancelUploadProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickCloseAiChat implements BaseEvent {
  event_type = 'Click Close - AI Chat';

  constructor(public event_properties?: ClickCloseAiChatProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickCommentCard implements BaseEvent {
  event_type = 'Click Comment Card';

  constructor(public event_properties?: ClickCommentCardProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickCommentsTopNavigation implements BaseEvent {
  event_type = 'Click Comments - Top Navigation';
}

export class ClickConceptGlossary implements BaseEvent {
  event_type = 'Click Concept - Glossary';

  constructor(public event_properties?: ClickConceptGlossaryProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickConfirmCode implements BaseEvent {
  event_type = 'Click Confirm Code';
}

export class ClickContinueButtonJourneyCard implements BaseEvent {
  event_type = 'Click Continue Button - Journey Card';

  constructor(public event_properties?: ClickContinueButtonJourneyCardProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickContinueLearning implements BaseEvent {
  event_type = 'Click Continue Learning';

  constructor(public event_properties: ClickContinueLearningProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickCtaButton implements BaseEvent {
  event_type = 'Click CTA button';

  constructor(public event_properties?: ClickCtaButtonProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickEditProfile implements BaseEvent {
  event_type = 'Click Edit Profile';
}

export class ClickHideMenu implements BaseEvent {
  event_type = 'Click Hide Menu';

  constructor(public event_properties?: ClickHideMenuProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickJourneyCard implements BaseEvent {
  event_type = 'Click Journey Card';

  constructor(public event_properties?: ClickJourneyCardProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickLink implements BaseEvent {
  event_type = 'Click Link';

  constructor(public event_properties: ClickLinkProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickLinkGlossary implements BaseEvent {
  event_type = 'Click Link - Glossary';

  constructor(public event_properties?: ClickLinkGlossaryProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickLogIn implements BaseEvent {
  event_type = 'Click Log in';
}

export class ClickLogInTopNavigation implements BaseEvent {
  event_type = 'Click Log in - Top Navigation';
}

export class ClickLogOutUserMenu implements BaseEvent {
  event_type = 'Click Log Out - User Menu';
}

export class ClickMarkAsComplete implements BaseEvent {
  event_type = 'Click Mark as Complete';

  constructor(public event_properties?: ClickMarkAsCompleteProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickModuleBar implements BaseEvent {
  event_type = 'Click Module Bar';

  constructor(public event_properties?: ClickModuleBarProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickMyPortfolioUserMenu implements BaseEvent {
  event_type = 'Click My Portfolio - User Menu';
}

export class ClickNext implements BaseEvent {
  event_type = 'Click Next';

  constructor(public event_properties?: ClickNextProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickPublishTopNavigation implements BaseEvent {
  event_type = 'Click Publish - Top Navigation';
}

export class ClickRemoveFile implements BaseEvent {
  event_type = 'Click Remove File';

  constructor(public event_properties: ClickRemoveFileProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickResendCode implements BaseEvent {
  event_type = 'Click Resend Code';
}

export class ClickReview implements BaseEvent {
  event_type = 'Click Review';
}

export class ClickRoadmapTopNavigation implements BaseEvent {
  event_type = 'Click Roadmap - Top Navigation';
}

export class ClickSaveEditProfile implements BaseEvent {
  event_type = 'Click Save - Edit Profile';
}

export class ClickScale implements BaseEvent {
  event_type = 'Click Scale';

  constructor(public event_properties?: ClickScaleProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickSendAiChat implements BaseEvent {
  event_type = 'Click Send - AI Chat';

  constructor(public event_properties?: ClickSendAiChatProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickSignUp implements BaseEvent {
  event_type = 'Click Sign Up';
}

export class ClickSignUpTopNavigation implements BaseEvent {
  event_type = 'Click Sign up - Top Navigation';
}

export class ClickSort implements BaseEvent {
  event_type = 'Click Sort';

  constructor(public event_properties?: ClickSortProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickStage implements BaseEvent {
  event_type = 'Click Stage';

  constructor(public event_properties?: ClickStageProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickStartAiChat implements BaseEvent {
  event_type = 'Click Start - AI Chat';

  constructor(public event_properties?: ClickStartAiChatProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickStartButton implements BaseEvent {
  event_type = 'Click Start Button';

  constructor(public event_properties?: ClickStartButtonProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickTabComments implements BaseEvent {
  event_type = 'Click Tab - Comments';

  constructor(public event_properties?: ClickTabCommentsProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickTabSubmissions implements BaseEvent {
  event_type = 'Click Tab - Submissions';

  constructor(public event_properties?: ClickTabSubmissionsProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickTakeAgain implements BaseEvent {
  event_type = 'Click Take Again';

  constructor(public event_properties: ClickTakeAgainProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickUploader implements BaseEvent {
  event_type = 'Click Uploader';

  constructor(public event_properties?: ClickUploaderProperties) {
    this.event_properties = event_properties;
  }
}

export class ClickView implements BaseEvent {
  event_type = 'Click View';
}

export class CopyOfClickComeBackLater implements BaseEvent {
  event_type = 'Copy of Click Come Back Later';

  constructor(public event_properties: CopyOfClickComeBackLaterProperties) {
    this.event_properties = event_properties;
  }
}

export class SelectLanguage implements BaseEvent {
  event_type = 'Select Language';

  constructor(public event_properties?: SelectLanguageProperties) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Add Editor
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Add%20Editor)
   *
   * Records when creator adds content inside the reading content.
   *
   * @param options Amplitude event options.
   */
  addEditor(
    options?: EventOptions,
  ) {
    return this.track(new AddEditor(), options);
  }

  /**
   * Click Activity Card - Portfolio
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Activity%20Card%20-%20Portfolio)
   *
   * records when the user clicks Activity Card in Portfolio or Comment on Peer's Work.
   *
   * @param properties The event's properties (e.g. pageContext)
   * @param options Amplitude event options.
   */
  clickActivityCardPortfolio(
    properties?: ClickActivityCardPortfolioProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickActivityCardPortfolio(properties), options);
  }

  /**
   * Click Add Comment
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Add%20Comment)
   *
   * records when the button to add comment is clicked (user clicks this button after typing their comment).
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickAddComment(
    properties?: ClickAddCommentProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickAddComment(properties), options);
  }

  /**
   * Click Add Section
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Add%20Section)
   *
   * Records when creators clicks the section type, to add the section.
   *
   * @param properties The event's properties (e.g. sectionType)
   * @param options Amplitude event options.
   */
  clickAddSection(
    properties?: ClickAddSectionProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickAddSection(properties), options);
  }

  /**
   * Click Answer Choice
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Answer%20Choice)
   *
   * records when an answer choice is clicked on multiple choice questions.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickAnswerChoice(
    properties?: ClickAnswerChoiceProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickAnswerChoice(properties), options);
  }

  /**
   * Click Avatar - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Avatar%20-%20Top%20Navigation)
   *
   * Records when avatar in the Top Navigation is clicked to open User Menu.
   *
   * @param options Amplitude event options.
   */
  clickAvatarTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickAvatarTopNavigation(), options);
  }

  /**
   * Click Back to Journey
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Back%20to%20Journey)
   *
   * records when user clicks Back to Journey button, on the final section of the journey.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickBackToJourney(
    properties: ClickBackToJourneyProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickBackToJourney(properties), options);
  }

  /**
   * Click Cancel - Edit Profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Cancel%20-%20Edit%20Profile)
   *
   * records when the user clicks Cancel in Edit Profile Page.
   *
   * @param options Amplitude event options.
   */
  clickCancelEditProfile(
    options?: EventOptions,
  ) {
    return this.track(new ClickCancelEditProfile(), options);
  }

  /**
   * Click Cancel Upload
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Cancel%20Upload)
   *
   * Tracks when user clicks cancel upload button (on the "upload content" section).
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickCancelUpload(
    properties: ClickCancelUploadProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickCancelUpload(properties), options);
  }

  /**
   * Click Close - AI Chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Close%20-%20AI%20Chat)
   *
   * Records when a user clicks close button to close the AI Chat Screen.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickCloseAiChat(
    properties?: ClickCloseAiChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickCloseAiChat(properties), options);
  }

  /**
   * Click Comment Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Comment%20Card)
   *
   * Records when user clicks Comment Card on Comments Page.
   *
   * @param properties The event's properties (e.g. commentsTab)
   * @param options Amplitude event options.
   */
  clickCommentCard(
    properties?: ClickCommentCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickCommentCard(properties), options);
  }

  /**
   * Click Comments - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Comments%20-%20Top%20Navigation)
   *
   * Records when user clicks Comments on Top Navigation.
   *
   * @param options Amplitude event options.
   */
  clickCommentsTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickCommentsTopNavigation(), options);
  }

  /**
   * Click Concept - Glossary
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Concept%20-%20Glossary)
   *
   * records when a user clicks on a concept in the glossary page to view its definition.
   *
   * @param properties The event's properties (e.g. concept)
   * @param options Amplitude event options.
   */
  clickConceptGlossary(
    properties?: ClickConceptGlossaryProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickConceptGlossary(properties), options);
  }

  /**
   * Click Confirm Code
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Confirm%20Code)
   *
   * Event that captures the user clicks "confirm" during the sign-up process.
   *
   * @param options Amplitude event options.
   */
  clickConfirmCode(
    options?: EventOptions,
  ) {
    return this.track(new ClickConfirmCode(), options);
  }

  /**
   * Click Continue Button - Journey Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Continue%20Button%20-%20Journey%20Card)
   *
   * This records when the Continue button is clicked on the Journey Card in Journey List Page.
   *
   * @param properties The event's properties (e.g. journey)
   * @param options Amplitude event options.
   */
  clickContinueButtonJourneyCard(
    properties?: ClickContinueButtonJourneyCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickContinueButtonJourneyCard(properties), options);
  }

  /**
   * Click Continue Learning
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Continue%20Learning)
   *
   * records when user clicks Continue Learning, on the final section of the module.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickContinueLearning(
    properties: ClickContinueLearningProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickContinueLearning(properties), options);
  }

  /**
   * Click CTA button
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20CTA%20button)
   *
   * records when learner clicks a CTA in activities (sections)
   *
   * @param properties The event's properties (e.g. ctaButtonType)
   * @param options Amplitude event options.
   */
  clickCtaButton(
    properties?: ClickCtaButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickCtaButton(properties), options);
  }

  /**
   * Click Edit Profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Edit%20Profile)
   *
   * records when the user clicks Edit Profile button on My Portfolio.
   *
   * @param options Amplitude event options.
   */
  clickEditProfile(
    options?: EventOptions,
  ) {
    return this.track(new ClickEditProfile(), options);
  }

  /**
   * Click Hide Menu
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Hide%20Menu)
   *
   * records when learner clicks hide menu
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickHideMenu(
    properties?: ClickHideMenuProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickHideMenu(properties), options);
  }

  /**
   * Click Journey Card
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Journey%20Card)
   *
   * This records when the Journey Card is clicked (anywhere on the card other than the 'Continue' button).
   *
   * @param properties The event's properties (e.g. journey)
   * @param options Amplitude event options.
   */
  clickJourneyCard(
    properties?: ClickJourneyCardProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickJourneyCard(properties), options);
  }

  /**
   * Click Link
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Link)
   *
   * records when user clicks on a hyperlink, capturing the destination URL and section they are on.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickLink(
    properties: ClickLinkProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickLink(properties), options);
  }

  /**
   * Click Link - Glossary
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Link%20-%20Glossary)
   *
   * records when a user clicks on a link in the glossary detail page to view its definition.
   *
   * @param properties The event's properties (e.g. concept)
   * @param options Amplitude event options.
   */
  clickLinkGlossary(
    properties?: ClickLinkGlossaryProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickLinkGlossary(properties), options);
  }

  /**
   * Click Log in
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Log%20in)
   *
   * Event that captures when a user clicks logs in button after entering log in info.
   *
   * @param options Amplitude event options.
   */
  clickLogIn(
    options?: EventOptions,
  ) {
    return this.track(new ClickLogIn(), options);
  }

  /**
   * Click Log in - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Log%20in%20-%20Top%20Navigation)
   *
   * Event to track when users click on the "Log in" button from the top navigation bar.
   *
   * @param options Amplitude event options.
   */
  clickLogInTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickLogInTopNavigation(), options);
  }

  /**
   * Click Log Out - User Menu
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Log%20Out%20-%20User%20Menu)
   *
   * Event that captures when a user clicks the "Log Out" button in the top menu.
   *
   * @param options Amplitude event options.
   */
  clickLogOutUserMenu(
    options?: EventOptions,
  ) {
    return this.track(new ClickLogOutUserMenu(), options);
  }

  /**
   * Click Mark as Complete
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Mark%20as%20Complete)
   *
   * records when learner clicks Come Back Later button in Comment on Peer's Work.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickMarkAsComplete(
    properties?: ClickMarkAsCompleteProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickMarkAsComplete(properties), options);
  }

  /**
   * Click Module Bar
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Module%20Bar)
   *
   * records when user clicks the Module bar on the journey detail page capturing which module is selected for deeper exploration.
   *
   * @param properties The event's properties (e.g. module)
   * @param options Amplitude event options.
   */
  clickModuleBar(
    properties?: ClickModuleBarProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickModuleBar(properties), options);
  }

  /**
   * Click My Portfolio - User Menu
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20My%20Portfolio%20-%20User%20Menu)
   *
   * Event that captures when a user clicks the "Log Out" button in the top menu.
   *
   * @param options Amplitude event options.
   */
  clickMyPortfolioUserMenu(
    options?: EventOptions,
  ) {
    return this.track(new ClickMyPortfolioUserMenu(), options);
  }

  /**
   * Click Next
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Next)
   *
   * Records when learner clicks next button in sections (and successfully processed).
   *
   * @param properties The event's properties (e.g. quizResultStatus)
   * @param options Amplitude event options.
   */
  clickNext(
    properties?: ClickNextProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickNext(properties), options);
  }

  /**
   * Click Publish - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Publish%20-%20Top%20Navigation)
   *
   * Records when creator clicks publish and the changes are pushed to the learner side.
   *
   * @param options Amplitude event options.
   */
  clickPublishTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickPublishTopNavigation(), options);
  }

  /**
   * Click Remove File
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Remove%20File)
   *
   * Tracks when user clicks remove upload (on the "upload content" section).
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickRemoveFile(
    properties: ClickRemoveFileProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickRemoveFile(properties), options);
  }

  /**
   * Click Resend Code
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Resend%20Code)
   *
   * Event is tracked when resend code is clicked during sign up  process.
   *
   * @param options Amplitude event options.
   */
  clickResendCode(
    options?: EventOptions,
  ) {
    return this.track(new ClickResendCode(), options);
  }

  /**
   * Click Review
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Review)
   *
   * Records when the creator clicks the button to review the activity under submitted.
   *
   * @param options Amplitude event options.
   */
  clickReview(
    options?: EventOptions,
  ) {
    return this.track(new ClickReview(), options);
  }

  /**
   * Click Roadmap - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Roadmap%20-%20Top%20Navigation)
   *
   * Records when user clicks Roadmap in the Top Navigation in the Journey Detail Page.
   *
   * @param options Amplitude event options.
   */
  clickRoadmapTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickRoadmapTopNavigation(), options);
  }

  /**
   * Click Save - Edit Profile
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Save%20-%20Edit%20Profile)
   *
   * records when the user clicks Save in Edit Profile Page.
   *
   * @param options Amplitude event options.
   */
  clickSaveEditProfile(
    options?: EventOptions,
  ) {
    return this.track(new ClickSaveEditProfile(), options);
  }

  /**
   * Click Scale
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Scale)
   *
   * records when the learner clicks the scale in Scale Question Section.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickScale(
    properties?: ClickScaleProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickScale(properties), options);
  }

  /**
   * Click Send - AI Chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Send%20-%20AI%20Chat)
   *
   * Records when a user clicks send button to send the ocnversation to the AI chat interface.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickSendAiChat(
    properties?: ClickSendAiChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickSendAiChat(properties), options);
  }

  /**
   * Click Sign Up
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Sign%20Up)
   *
   * Event that captures when a user clicks the sign-up button on the sign-up page.
   *
   * @param options Amplitude event options.
   */
  clickSignUp(
    options?: EventOptions,
  ) {
    return this.track(new ClickSignUp(), options);
  }

  /**
   * Click Sign up - Top Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Sign%20up%20-%20Top%20Navigation)
   *
   * Event to track when users click on the "Sign up" button on the Top section of the page.
   *
   * @param options Amplitude event options.
   */
  clickSignUpTopNavigation(
    options?: EventOptions,
  ) {
    return this.track(new ClickSignUpTopNavigation(), options);
  }

  /**
   * Click Sort
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Sort)
   *
   * Tracks when the user clicks the sort button in each column under submissions.
   *
   * @param properties The event's properties (e.g. submissionsColumn)
   * @param options Amplitude event options.
   */
  clickSort(
    properties?: ClickSortProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickSort(properties), options);
  }

  /**
   * Click Stage
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Stage)
   *
   * Records when stage block is clicked in the Journey Detail Page.
   *
   * @param properties The event's properties (e.g. stage)
   * @param options Amplitude event options.
   */
  clickStage(
    properties?: ClickStageProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickStage(properties), options);
  }

  /**
   * Click Start - AI Chat
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Start%20-%20AI%20Chat)
   *
   * Records when a user initiates a conversation with the AI chat interface by clicking the start button.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickStartAiChat(
    properties?: ClickStartAiChatProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickStartAiChat(properties), options);
  }

  /**
   * Click Start Button
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Start%20Button)
   *
   * Records start button clicks on the journey detail page.
   *
   * @param properties The event's properties (e.g. module)
   * @param options Amplitude event options.
   */
  clickStartButton(
    properties?: ClickStartButtonProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickStartButton(properties), options);
  }

  /**
   * Click Tab - Comments
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Tab%20-%20Comments)
   *
   * Records when user clicks a tab (received, given) on Comments Page.
   *
   * @param properties The event's properties (e.g. commentsTab)
   * @param options Amplitude event options.
   */
  clickTabComments(
    properties?: ClickTabCommentsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickTabComments(properties), options);
  }

  /**
   * Click Tab - Submissions
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Tab%20-%20Submissions)
   *
   * Tracks when a creator selects the "reviewed" or "submitted" tab under submissions
   *
   * @param properties The event's properties (e.g. submissionTab)
   * @param options Amplitude event options.
   */
  clickTabSubmissions(
    properties?: ClickTabSubmissionsProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickTabSubmissions(properties), options);
  }

  /**
   * Click Take Again
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Take%20Again)
   *
   * records when user clicks Take Again in the result page (fail state) of a question section.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickTakeAgain(
    properties: ClickTakeAgainProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickTakeAgain(properties), options);
  }

  /**
   * Click Uploader
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20Uploader)
   *
   * Tracks when user clicks uploader section, to upload content (on the "upload content" section.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  clickUploader(
    properties?: ClickUploaderProperties,
    options?: EventOptions,
  ) {
    return this.track(new ClickUploader(properties), options);
  }

  /**
   * Click View
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Click%20View)
   *
   * Records when the creator clicks the button to view the activity submission page. For creator, the button is in submission page reviewed tab and for learner, the button is in submission page.
   *
   * @param options Amplitude event options.
   */
  clickView(
    options?: EventOptions,
  ) {
    return this.track(new ClickView(), options);
  }

  /**
   * Copy of Click Come Back Later
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Copy%20of%20Click%20Come%20Back%20Later)
   *
   * records when learner clicks Mark as Complete button in Comment on Peer's Work.
   *
   * @param properties The event's properties (e.g. section)
   * @param options Amplitude event options.
   */
  copyOfClickComeBackLater(
    properties: CopyOfClickComeBackLaterProperties,
    options?: EventOptions,
  ) {
    return this.track(new CopyOfClickComeBackLater(properties), options);
  }

  /**
   * Select Language
   *
   * [View in Tracking Plan](https://data.amplitude.com/fujitsu-launchpad/Vega/events/main/latest/Select%20Language)
   *
   * Event to track when a user selects a language preference on the platform.
   *
   * @param properties The event's properties (e.g. language)
   * @param options Amplitude event options.
   */
  selectLanguage(
    properties?: SelectLanguageProperties,
    options?: EventOptions,
  ) {
    return this.track(new SelectLanguage(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
